/* src/app/commonComponents/modals/default-modals/transfer-between-accounts-modal/transfer-between-accounts-modal.component.scss */
.transfer-between-accounts {
  width: 540px;
  min-height: 542px;
}
.transfer-between-accounts .content-container {
  padding: 0 20px;
  padding-top: 20px;
  flex: 1;
  transition: 0.4s ease;
  width: 100%;
}
.transfer-between-accounts .modal-container {
  width: 540px;
}
.transfer-between-accounts .modal-footer {
  justify-content: flex-end;
}
.transfer-between-accounts .description-input {
  margin-bottom: 20px;
}
.transfer-between-accounts .description-input textarea {
  height: 100px;
}
.transfer-between-accounts .amount-with-currency .text-select-field {
  align-items: center;
  margin-bottom: 8px;
}
.transfer-between-accounts .amount-with-currency .text-select-field .currency {
  background: #1252AF;
  display: block;
  padding: 1px 6px;
  font-size: 10px;
  font-weight: 600;
  color: white;
  margin-left: 6px;
  width: 33px;
  height: 16px;
}
.transfer-between-accounts .current-rate {
  margin-bottom: 10px;
  color: #637283;
  font-size: 13px;
  display: flex;
  align-items: center;
}
.transfer-between-accounts .current-rate .rate {
  color: #1252AF;
}
.transfer-between-accounts .current-rate .j-icon-edit {
  color: #1252AF;
  margin-left: 5px;
  cursor: pointer;
}
.transfer-between-accounts .title-text {
  display: flex;
  align-items: center;
}
.transfer-between-accounts .title-text .j2-icon-transfer {
  margin-right: 6px;
  color: #fff;
}
.transfer-between-accounts .input-container .e-input-value {
  width: calc(100% - 34px);
}
.transfer-between-accounts .input-container .value {
  height: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 100%;
  display: block;
  padding-top: 7px;
  padding-left: 8px;
}
.template-bank-account {
  display: flex;
  align-items: center;
  justify-content: space-between;
  line-height: normal;
}
.template-bank-account .info {
  display: flex;
  flex-direction: column;
  height: 46px;
  max-height: 46px;
  padding-top: 4px;
}
.template-bank-account .info .name {
  font-weight: 600;
  margin-bottom: 1px;
  display: block;
  margin-bottom: 1;
}
.template-bank-account .info .number {
  font-size: 13px;
  color: #637283;
  display: block;
  margin-bottom: 1;
}
.template-bank-account .balance {
  height: 46px;
  max-height: 46px;
  padding-top: 4px;
}
